import { ICluster } from "./cluster";

export interface IClusterListResponse {
    data: {
        success: boolean;
        results: ICluster[];
    }
}